export type valueType = string | number | boolean;

export function getIndexes(values: valueType[]): number[] {
  return values?.reduce(
    (acc: number[], value: valueType, i: number) =>
      value !== undefined ? [...acc, i] : acc,
    []
  );
}
